export default {
  title: '{{title}}',
  termsUseTitle: 'General Terms of Use',
  protectionInfoTitle: 'Protection of Personal Information',
  contentTable: 'Table of contents',
};
